import { render, staticRenderFns } from "./ParkFlashIndex.vue?vue&type=template&id=8896d836"
import script from "./ParkFlashIndex.vue?vue&type=script&lang=js"
export * from "./ParkFlashIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports